package com.trevorwiebe.timesheet.admin.usermanagement.presentation

import com.trevorwiebe.timesheet.core.domain.model.DatabaseUserModel
import com.trevorwiebe.timesheet.core.domain.model.OwnerOperator

data class UserManagementState(
    val users: List<DatabaseUserModel> = emptyList(),
    val ownerOperators: List<OwnerOperator> = emptyList(),
    val showAddEditDialog: Boolean = false,
    val editingUser: DatabaseUserModel? = null,
    val showDeleted: Boolean = false,
    val isLoading: Boolean = false,
    val isSaving: Boolean = false,
    val isSendingPasswordReset: Boolean = false,
    val passwordResetEmailSent: Boolean = false,
    val error: String? = null,
    val currentUserId: String? = null,
) {
    val activeUsers: List<DatabaseUserModel> = users.filter { !it.deleted }
    val deletedUsers: List<DatabaseUserModel> = users.filter { it.deleted }
}
